import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const briefFormState = (state: AppState) => state.briefForm;

export const getBriefForm = createSelector(briefFormState, ({ briefForm }) => briefForm);

export const hasFormBeenSubmitted = createSelector(briefFormState, ({ submitted }) => submitted);

export const getBriefFormProcessingStatus = createSelector(briefFormState, ({ isProcessing, hasError }) => ({
    isProcessing,
    hasError,
}));
